import { viewportActions } from '@starflow/app/store';
import { Shape, ShapeTool, DrawingRect, DrawingCircle } from '@shakkerai/pro-atoms';
import helpers from '@starflow/app/helpers';
import { setProjectState } from '@starflow/app/store';
import { translate } from '@shakkerai/util-i18n';

const insertSquare = ({ x, y, width = 1024, height = 1024 }, { autoFocus = false } = {}) => {
  const elementId = helpers.canvas.insertElement({
    type: 'shape_square',
    x,
    y,
    width,
    height,
    data: { shape: 'square', backgroundColor: '#969696', width, height },
  });

  setProjectState({ selection: [elementId] });
  autoFocus && viewportActions.locateElement(elementId, { animate: true });
};

const insertCircle = ({ x, y, scaleX, scaleY, width = 1024, height = 1024 }, { autoFocus = false } = {}) => {
  const elementId = helpers.canvas.insertElement({
    type: 'shape_circle',
    x,
    y,
    width,
    height,
    scaleX,
    scaleY,
    data: { shape: 'circle', backgroundColor: '#969696', width, height },
  });

  setProjectState({ selection: [elementId] });
  autoFocus && viewportActions.locateElement(elementId, { animate: true });
};

export default {
  setup: ({ app }) => {
    app.extension.registerElement('shape_square', {
      element: Shape,
      toolbar: ShapeTool,
      tool: {
        icon: 'shk-juxing',
        label: 'Square',
        cursor: `image-set(url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNSA4LjVWMTkuNU0xMiAxNEgxIiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi4yNSAxMy43NVY5SDYuNzVWMTMuNzVIMTEuNVYxNC4yNUg2Ljc1VjE5SDYuMjVWMTQuMjVIMS41VjEzLjc1SDYuMjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgMC41SDIwVjExLjVIOVYwLjVaTTEwIDEuNVYxMC41SDE5VjEuNUgxMFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkgMS41SDEwVjEwLjVIMTlWMS41Wk05LjUgMVYxMUgxOS41VjFIOS41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==") 1dppx) 7 18, auto`,
        hotkey: 'R',
        tooltip: translate('tool_r'),
        drawable: true,
        drawingElement: DrawingRect,
        handler: ({ rect }) => {
          // 如果是拖动绘制完成的，会有rect，如果是点击的则只有position
          const width = !rect.width || rect.width < 3 ? 1024 : rect.width;
          const height = !rect.height || rect.height < 3 ? 1024 : rect.height;

          insertSquare({
            ...rect,
            width,
            height,
          });

          // 这里return true可以在执行完当前动作后立即退出
          return true;
        },
      },
      config: {
        rotateEnabled: true,
        keepRatio: false,
        resizeAnchors: null,
      },
    });

    app.extension.registerElement('shape_circle', {
      element: Shape,
      toolbar: ShapeTool,
      tool: {
        icon: 'shk-yuanxing',
        label: 'Circle',
        cursor: `image-set(url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNSA4LjVWMTkuNU0xMiAxNEgxIiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi4yNSAxMy43NVY5SDYuNzVWMTMuNzVIMTEuNVYxNC4yNUg2Ljc1VjE5SDYuMjVWMTQuMjVIMS41VjEzLjc1SDYuMjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgNkM5IDIuOTYyNDMgMTEuNDYyNCAwLjUgMTQuNSAwLjVDMTcuNTM3NiAwLjUgMjAgMi45NjI0MyAyMCA2QzIwIDkuMDM3NTcgMTcuNTM3NiAxMS41IDE0LjUgMTEuNUMxMS40NjI0IDExLjUgOSA5LjAzNzU3IDkgNlpNMTQuNSAxLjVDMTIuMDE0NyAxLjUgMTAgMy41MTQ3MiAxMCA2QzEwIDguNDg1MjggMTIuMDE0NyAxMC41IDE0LjUgMTAuNUMxNi45ODUzIDEwLjUgMTkgOC40ODUyOCAxOSA2QzE5IDMuNTE0NzIgMTYuOTg1MyAxLjUgMTQuNSAxLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDZDMTAgOC40ODUyOCAxMi4wMTQ3IDEwLjUgMTQuNSAxMC41QzE2Ljk4NTMgMTAuNSAxOSA4LjQ4NTI4IDE5IDZDMTkgMy41MTQ3MiAxNi45ODUzIDEuNSAxNC41IDEuNUMxMi4wMTQ3IDEuNSAxMCAzLjUxNDcyIDEwIDZaTTE0LjUgMUMxMS43Mzg2IDEgOS41IDMuMjM4NTggOS41IDZDOS41IDguNzYxNDIgMTEuNzM4NiAxMSAxNC41IDExQzE3LjI2MTQgMTEgMTkuNSA4Ljc2MTQyIDE5LjUgNkMxOS41IDMuMjM4NTggMTcuMjYxNCAxIDE0LjUgMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=") 1dppx) 7 18, auto`,
        hotkey: 'O',
        tooltip: translate('tool_o'),
        drawable: true,
        drawingElement: DrawingCircle,
        handler: ({ rect, shiftPressing }) => {
          const width = !rect.width || rect.width < 3 ? 1024 : rect.width;
          const height = !rect.height || rect.height < 3 ? 1024 : rect.height;

          const maxSide = Math.max(width, height);
          const scaleX = shiftPressing ? 1 : width / maxSide;
          const scaleY = shiftPressing ? 1 : height / maxSide;

          // 计算起点坐标
          const edgeX = rect.x;
          const edgeY = rect.y;

          insertCircle({
            x: edgeX,
            y: edgeY,
            scaleX: scaleX,
            scaleY: scaleY,
            width: maxSide,
            height: maxSide,
            radius: 1,
          });

          // 这里return true可以在执行完当前动作后立即退出
          return true;
        },
      },
      config: {
        rotateEnabled: true,
        keepRatio: false,
        resizeAnchors: null,
      },
    });
  },
};
